import { Component, OnInit, Input } from '@angular/core';
import { Experience, WMAIApiService } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService} from '@ngx-translate/core'

@Component({
  selector: 'app-esperienzashare-main-details',
  templateUrl: './esperienzashare-main-details.component.html'
})
export class EsperienzaShareMainDetailsComponent implements OnInit {
  public id: number;

  @Input() esperienza: Experience;
  constructor(
    private wmaiservice: WMAIApiService,
    private activatedroute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService
  ) {

  }

  ngOnInit() {
    if (this.activatedroute.snapshot.params.id != null && parseInt(this.activatedroute.snapshot.params.id)) {
      this.id = this.activatedroute.snapshot.params.id;
      if (this.id != null) {
        this.wmaiservice.querySingleEsperienza(this.id, this.translateService.getDefaultLang()).subscribe(data => {
          this.esperienza = data['data'][0];
        })
      }
    }
  }
}
